.root {
  min-height: 100vh;
  min-height: 100svh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  padding: 32px 24px;
  background: #f7f5f2;
  text-align: center;
}

.brand {
  font-family: 'Bricolage Grotesque', sans-serif;
  font-weight: 600;
  font-size: 18px;
  letter-spacing: 0.02em;
  color: #27231c;
  opacity: 0.7;
  text-transform: uppercase;
}

.title {
  font-family: 'Bricolage Grotesque', sans-serif;
  font-weight: 700;
  font-size: clamp(48px, 10vw, 120px);
  letter-spacing: -0.02em;
  line-height: 1;
  color: #27231c;
  margin: 0;
}

.subtitle {
  font-family: 'DM Sans', sans-serif;
  font-weight: 400;
  font-size: clamp(16px, 2.2vw, 20px);
  line-height: 1.5;
  color: #27231c;
  opacity: 0.7;
  max-width: 540px;
  margin: 0;
}

.dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 9999px;
  background: #2ca89e;
  margin-left: 8px;
  vertical-align: middle;
  animation: pulse 1.8s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.4; transform: scale(0.85); }
}
